<template>
  <div class="dataStatistics">
    <!-- 计算说明 -->
    <a-modal
      v-model="isRemarkShow"
      :width="641"
      :title="$t('dataReport.calculation')"
      @ok="isRemarkShow = false"
    >
      <ul class="remarkUl">
        <li
          v-for="r in remarkList[lang]"
          :key="r.label"
        >
          <i>{{ r.label }}</i>{{ r.content }}
        </li>
      </ul>
    </a-modal>

    <!-- 标题 -->
    <h1 class="customerName">{{ customerName }}</h1>

    <!-- 设备选择区域 -->
    <section class="device_selector">
      <div style="display: flex; justify-content: space-between; align-items: center; min-height: 100px;" v-show="isDeviceLoading">
        <a-spin size="small" />
      </div>
      <div class="device_wrapper" v-show="!isDeviceLoading">
        <header>
          <h3>{{ $t("station.NXFXY") }}</h3>
          <span @click="changeDeviceFolding">
            {{ messageOfDeviceFold }}
            <a-icon type="double-right" v-show="isDeviceFold" />
            <a-icon type="double-left" v-show="!isDeviceFold" />
          </span>
        </header>
        <div class="splitLine"></div>
        <ul class="devices" v-show="!isDeviceFold">
          <li
            v-for="d in devices"
            :key="d.code"
            :title="d.title"
          >
            <label :for="d.code">
              <span :title="d.name" class="device_name">
                {{ d.name.slice(0, 9) }}
              </span>
              <input
                v-model="d.selected"
                :id="d.code"
                type="checkbox"
              />
            </label>
          </li>
        </ul>
      </div>
    </section>

    <!-- 主体 -->
    <section class="content_wrapper">
      <a-spin size="large" class="loader" v-show="isContentLoading" />
      <div class="content" v-show="!isContentLoading">
        <!-- 参数设置及按钮 -->
        <div class="controller">
          <span
            v-for="t in timeTypes"
            :key="t.key"
            :class="{ active: activeTimeType === t.key }"
            @click="changeTimeType(t.key)"
          >
            {{ $t(t.text) }}
          </span>
          <el-date-picker
            v-show="activeTimeType === 'day'"
            v-model="dayDate"
            size="small"
            type="date"
            :clearable="false"
            :key="lang"
            @change="reload"
          />
          <el-date-picker
            v-show="activeTimeType === 'month'"
            v-model="monthDate"
            unlink-panels
            size="small"
            type="daterange"
            :clearable="false"
            :key="lang + '1'"
            :picker-options="pickerOptions"
            @change="reload"
          />
          <el-date-picker
            v-show="activeTimeType === 'year'"
            v-model="yearDate"
            unlink-panels
            size="small"
            type="daterange"
            :clearable="false"
            :key="lang + '2'"
            :picker-options="pickerOptions"
            @change="reload"
          />
          <a-select
            v-model="unit"
            style="width: 120px; margin-left: 12px;"
            dropdownClassName="selectOption"
          >
            <a-select-option value="m³">m³</a-select-option>
            <a-select-option value="Nm³">Nm³</a-select-option>
          </a-select>
          <div class="buttons">
            <a-button type="primary" @click="reload">
              {{ $t("buttons.search") }}
            </a-button>
            <a-button type="primary" :loading="isExporting" @click="exportAsExcel">
              {{ $t("buttons.export") }}
            </a-button>
            <a-button type="primary" @click="showAggregate">
              {{ $t("device.distribution") }}
            </a-button>
          </div>
          <a-button type="primary" style="float: right;" @click="isRemarkShow = true">
            {{ $t("dataReport.calculation") }}
          </a-button>
        </div>

        <!-- 表格 -->
        <div class="table_wrapper">
          <table>
            <thead>
              <tr>
                <th
                  v-for="c in columns"
                  :key="c.key"
                >
                  {{ c[lang] }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="d in datas"
                :key="d.datetime"
              >
                <td
                  v-for="c in columns"
                  :key="c.key"
                >
                  {{ c.fixed ? d[c.dataIndex].toFixed(c.fixed) : d[c.dataIndex] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 图表 -->
        <div class="charts_group_wrapper">
          <ul class="types">
            <li
              :class="{ active: activeChartType === 'line' }"
              @click="changeChartType('line')"
            >
              {{ $t("line") }}
            </li>
            <li
              :class="{ active: activeChartType === 'bar' }"
              @click="changeChartType('bar')"
            >
              {{ $t("bar") }}
            </li>
          </ul>
          <ul class="charts_group">
            <li
              v-for="p in pointsOfCharts"
              :key="p.key"
            >
              <h3>{{ p.title[lang] }}</h3>
              <hr />
              <div class="chart_wrapper">
                <div class="tooltip">
                  <p>{{ $t("min") }} {{ p.min }}</p>
                  <p>{{ $t("max") }} {{ p.max }}</p>
                </div>
                <div class="chart" :id="p.key"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 数据分布区间统计 -->
    <div ref="aggregate" class="mask aggregate" @mousedown="startDrag" v-show="isAggregateVisible" v-loading="isAggregateLoading">
      <a-icon type="close" @click="clearAggregate" />
      <div class="wrapper" @mousedown.stop="">
        <header class="header">
          <h2 style="display: inline-block;">
            {{ customerName }}
          </h2>
        </header>
        <section class="device_selector">
          <div class="device_wrapper">
            <header>
              <h3>{{ $t("station.NXFXY") }}</h3>
              <span @click="changeDeviceFold_aggregate">
                {{ messageOfDeviceFold_aggregate }}
                <a-icon type="double-right" v-show="isDeviceFold_aggregate" />
                <a-icon type="double-left" v-show="!isDeviceFold_aggregate" />
              </span>
            </header>
            <div class="splitLine"></div>
            <ul class="devices" v-show="!isDeviceFold_aggregate">
              <li
                v-for="d in devices_aggregate"
                :key="d.code"
                :title="d.title"
              >
                <label :for="d.code + '_aggregate'">
                  <span :title="d.name" class="device_name">
                    {{ d.name.slice(0, 9) }}
                  </span>
                  <input
                    v-model="d.selected"
                    :id="d.code + '_aggregate'"
                    type="checkbox"
                  />
                </label>
              </li>
            </ul>
          </div>
        </section>
        <!-- <ul class="headerNav">
          <li :class="{ fold: isDeviceFold_aggregate }" style="width: 100%">
            <header>
              <h3>{{ $t("station.NXFXY") }}</h3>
              <span @click="changeDeviceFold_aggregate">
                {{ messageOfDeviceFold_aggregate }}
                <a-icon type="double-right" v-show="isDeviceFold_aggregate" />
                <a-icon type="double-left" v-show="!isDeviceFold_aggregate" />
              </span>
              <div class="border"></div>
            </header>
            <section class="nav_body" v-show="!isDeviceFold_aggregate">
              <ul>
                <li
                  v-for="f in devices_aggregate"
                  :key="f.code"
                  :title="f.title"
                >
                  <label :for="f.code + '_aggregate'">
                    <span :title="f.name" class="device_name">
                      {{ f.name.slice(0, 9) }}
                    </span>
                    <input
                      v-model="f.selected"
                      :id="f.code + '_aggregate'"
                      type="checkbox"
                    />
                  </label>
                </li>
              </ul>
            </section>
          </li>
        </ul> -->
        <div class="search">
          <el-date-picker
            type="datetimerange"
            size="small"
            style="background-color: #2f3d4f"
            v-model="aggregateTimeValue"
            :default-time="['00:00:00', '23:59:59']"
          />
          <label style="margin-left: 25px;">
            {{ $t("dataReport.points") }}: 
            <a-select dropdownClassName="selectOption" :placeholder="$t('device.selectPoints')" style="width: 140px; background-color: #2f3d4f; margin-left: 6px;" :notFoundContent="$t('common.nd')" :getPopupContainer="getPopupContainer" v-model="selectedPoint">
              <a-select-option
                v-for="f in pointsOptions"
                :key="f.code"
              >
                {{ f.name }}
              </a-select-option>
            </a-select>
          </label>
          <a-button type="primary" style="margin-left: 30px;" @click="addRange_aggregate">{{ $t("device.addRange") }}</a-button>
          <a-button v-show="ranges_aggregate.length" type="primary" style="margin-left: 10px;" @click="deleteLastRange">{{ $t("device.removeRange") }}</a-button>
          <a-button v-show="ranges_aggregate.length" type="primary" style="margin-left: 10px;" @click="analyse_aggregate" :loading="isAggregateAnalysing">{{ $t("device.analysis") }}</a-button>
        </div>
        <div class="content">
          <div class="left">
            <div class="top">
              <h3>{{ $t("device.range") }}: </h3>
              <ul class="ranges">
                <li
                  v-for="(r, i) in ranges_aggregate"
                  :key="r.id"
                >
                  <a-input v-model="r.min" style="width: 60px;" />
                  <span style="margin-left: 6px;">≤</span>
                  <span style="margin: 0 6px;">{{ $t("device.range") }}<span :class="{ ml: i < 9 }">{{ i + 1 }}</span></span>
                  <span style="margin-right: 6px;">&lt;</span>
                  <a-input v-model="r.max" style="width: 60px;" />
                </li>
              </ul>
            </div>
            <div class="bottom">
              <h3>{{ $t("dataReport.origin") }}: </h3>
              <div class="chart" id="origin"></div>
            </div>
          </div>
          <div class="right">
            <h3>{{ $t("dataReport.result") }}: </h3>
            <div class="chart" id="pie"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  searchDeviceList,
  getNXFXYDayReportData,
  getNXFXYMonthReportData,
  getNXFXYYearReportData,
  exportNXFXYDayReportData,
  exportNXFXYMonthReportData,
  exportNXFXYYearReportData,
  getAggregateHistoryData
} from "@/api/device"
import { getProtocol } from "@/api/protocol"
import { nanoid } from "nanoid"

import moment from "moment"
import zh from "element-ui/lib/locale/lang/zh-CN"
import en from "element-ui/lib/locale/lang/en"
import locale from "element-ui/lib/locale"

export default {
  data() {
    return {
      en,
      zh,
      /* 计算说明 */
      isRemarkShow: false,
      remarkList: {},
      /* 标题 */
      customerName: "",
      /* 设备选择区域 */
      isDeviceLoading: true,
      messageOfDeviceFold: "",
      isDeviceFold: false,
      devices: [
        {
          code: "1",
          name: "xxxxxxxxxxxxxxxxxxx",
          selected: false
        }
      ],
      /* 主体 */
      isContentLoading: true,
      /* 主体_参数设置及按钮 */
      timeTypes: [
        {
          key: "day",
          text: "dataReport.day"
        },
        {
          key: "month",
          text: "dataReport.month"
        },
        {
          key: "year",
          text: "dataReport.year"
        }
      ],
      activeTimeType: "day",
      pickerOptions: {},
      dayDate: null,
      monthDate: null,
      yearDate: null,
      unit: "m³",
      isExporting: false,
      /* 主体_表格 */
      columns: [],
      datas: [],
      /* 主体_图表 */
      activeChartType: "bar",
      pointsOfCharts: [],
      /* 数据分布区间统计 */
      isAggregateVisible: false,
      isAggregateLoading: false,
      isDeviceFold_aggregate: false,
      messageOfDeviceFold_aggregate: "",
      devices_aggregate: [],
      aggregateTimeValue: null,
      selectedPoint: "",
      pointsOptions: [],
      ranges_aggregate: [],
      isAggregateAnalysing: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  created() {
    this.setRemarkList()
    this.remarkList = this.dayRemarkList

    this.setTimes()

    this.setColumns(this.unit)

    this.setPoints(this.unit)

    this.translate()
  },
  mounted() {
    this.render()
  },
  beforeDestroy() {
    document.removeEventListener("mouseup", this.unbindMove)
  },
  methods: {
    /* 初始化 */
    setRemarkList() {
      this.dayRemarkList = {
        en: [
          {
            label: "",
            content: "The following uses 08:00:00 on October 10 as an example"
          },
          {
            label: "Daily: ",
            content: "Distinguish by hour, 08:00:00 indicates the usage between 7:00 and 8:00"
          },
          {
            label: "Average Gas Consumption: ",
            content: "(Meter accumulation at 8 points - meter accumulation at 7 points)/60 minutes"
          },
          {
            label: "Flow Meter Accumulation: ",
            content: "Flow meter accumulation at 8 o'clock"
          },
          {
            label: "Power per hour: ",
            content: "(Electricity meter accumulation at 8 o'clock - electricity meter accumulation at 7 o'clock) / 1 hour"
          },
          {
            label: "Electricity Meter Accumulation: ",
            content: "Electricity meter accumulation at 8 o'clock"
          },
          {
            label: "Average Pressure: ",
            content: "Pressure values read at 8 o'clock Total / points number"
          },
          {
            label: "Average Consumption: ",
            content: "(Electricity meter accumulation at 8 o 'clock - electricity meter accumulation at 7 o 'clock) / (flow meter accumulation at 8 o 'clock - flow meter accumulation at 7 o 'clock)"
          },
          {
            label: "Cumulative total for the day: ",
            content: "Electricity or gas accumulation at 24:00 on October 10 - Electricity or gas accumulation at 24:00 on October 9"
          }
        ],
        zh: [
          {
            label: "",
            content: "以下用10月10日08:00:00为例"
          },
          {
            label: "按日：",
            content: "以小时为单位，08:00:00为7点-8点的用量"
          },
          {
            label: "平均用气量：",
            content: "(8点的流量计累积-7点的流量计累积)/60分钟"
          },
          {
            label: "流量计累积：",
            content: "8点时的流量计累积量"
          },
          {
            label: "小时用电量：",
            content: "(8点的电表累积-7点的电表累积)/1小时"
          },
          {
            label: "电表累积：",
            content: "8点时的电表累积量"
          },
          {
            label: "平均压力：",
            content: "7点-8点间读取到的压力值合计/读取到的点数"
          },
          {
            label: "平均单耗：",
            content: "(8点的电表累积-7点的电表累积)/(8点的流量计累积-7点的流量计累积)"
          },
          {
            label: "本日累积合计值：",
            content: "10月10日24:00:00的电量或气量累计-10月9日24:00:00的电量或气量累计"
          }
        ]
      }
      this.monthRemarkList = {
        en: [
          {
            label: "",
            content: "Take October 10 as an example"
          },
          {
            label: "Monthly: ",
            content: "Distinguish by day"
          },
          {
            label: "Average Gas Consumption: ",
            content: "(Flow meter accumulation on October 10 - Flow meter accumulation on October 9) / 24 hours / 60 minutes"
          },
          {
            label: "Flow Meter Accumulation: ",
            content: "Flow meter accumulation at 24 o 'clock on October 10"
          },
          {
            label: "Power per hour: ",
            content: "(Electricity meter accumulation on October 10 - electricity meter accumulation on October 9) / 24 hours"
          },
          {
            label: "Electricity Meter Accumulation: ",
            content: "Electricity meter accumulation at 24 o 'clock on October 10"
          },
          {
            label: "Average Pressure: ",
            content: "Pressure values read on October 10 Total / points number"
          },
          {
            label: "Average Consumption: ",
            content: "(Electricity meter accumulation at 24 o 'clock on October 10 - meter accumulation at 24 points on October 9) / (flow meter accumulation at 24 points on October 10 - flow meter accumulation at 24 o 'clock on October 9)"
          },
          {
            label: "Cumulative total for the month: ",
            content: "Electricity or gas accumulation at 24:00 on October 31 - Electricity or gas accumulation at 24:00 on September 30"
          }
        ],
        zh: [
          {
            label: "",
            content: "以下用10月10日为例"
          },
          {
            label: "按月：",
            content: "以天为单位"
          },
          {
            label: "平均用气量：",
            content: "(10月10日的流量计累积-10月9日的流量计累积)/24小时/60分钟"
          },
          {
            label: "流量计累积：",
            content: "10月10日24点时的流量计累积量"
          },
          {
            label: "小时用电量：",
            content: "(10月10日的电表累积-10月9日的电表累积)/24小时"
          },
          {
            label: "电表累积：",
            content: "10月10日24点时的电表累积量"
          },
          {
            label: "平均压力：",
            content: "10月10日读取到的压力值合计/读取到的点数"
          },
          {
            label: "平均单耗：",
            content: "(10月10日24点的电表累积-10月9日24点的电表累积)/(10月10日24点的流量计累积-10月9日24点的流量计累积)"
          },
          {
            label: "本月累积合计值：",
            content: "10月31日24:00:00的电量或气量累计-9月30日24:00:00的电量或气量累计"
          }
        ]
      }
      this.yearRemarkList = {
        en: [
          {
            label: "",
            content: "Take October 2024 as an example"
          },
          {
            label: "Yearly: ",
            content: "Distinguish by month"
          },
          {
            label: "Average Gas Consumption: ",
            content: "(Flow meter accumulation on October 31 - Flow meter accumulation on September 30) / 31 days / 24 hours / 60 minutes"
          },
          {
            label: "Flow Meter Accumulation: ",
            content: "Flow meter accumulation at 24 o 'clock on October 31"
          },
          {
            label: "Power per hour: ",
            content: "(Electricity meter accumulation on October 31 - electricity meter accumulation on September 30) / 31 days /  24 hours"
          },
          {
            label: "Electricity Meter Accumulation: ",
            content: "Electricity meter accumulation at 24 o 'clock on October 31"
          },
          {
            label: "Average Pressure: ",
            content: "Pressure values read on October Total / points number"
          },
          {
            label: "Average Consumption: ",
            content: "(Electricity meter accumulation at 24 o 'clock on October 31 - meter accumulation at 24 points on September 30) / (flow meter accumulation at 24 points on October 31 - flow meter accumulation at 24 o 'clock on September 30)"
          },
          {
            label: "Cumulative total for the month: ",
            content: "Electricity or gas accumulation at 24:00 on December 31, 2025 - Electricity or gas accumulation at 24:00 on December 31, 2024"
          }
        ],
        zh: [
          {
            label: "",
            content: "以下用2024年10月为例"
          },
          {
            label: "按年：",
            content: "以月为单位"
          },
          {
            label: "平均用气量：",
            content: "(10月31日的流量计累积-9月30日的流量计累积)/31天/24小时/60分钟"
          },
          {
            label: "流量计累积：",
            content: "10月31日24点时的流量计累积量"
          },
          {
            label: "小时用电量：",
            content: "(10月31日的电表累积-9月30日的电表累积)/31天/24小时"
          },
          {
            label: "电表累积：",
            content: "10月31日24点时的电表累积量"
          },
          {
            label: "平均压力：",
            content: "10月读取到的压力值合计/读取到的点数"
          },
          {
            label: "平均单耗：",
            content: "(10月31日24点的电表累积-9月30日24点的电表累积)/(10月31日24点的流量计累积-9月30日24点的流量计累积)"
          },
          {
            label: "本年累积合计值：",
            content: "2024年12月31日24:00:00的电量或气量累计-2023年12月31日24:00:00的电量或气量累计"
          }
        ]
      }
    },
    setTimes() {
      const now = new Date()

      // 日
      this.dayDate = new Date(now)

      // 月
      let monthEnd = new Date(now)
      let monthStart = new Date(now)
      monthStart.setMonth(monthEnd.getMonth() - 1)
      this.monthDate = [monthStart, monthEnd]

      // 年
      let yearEnd = new Date(now)
      let yearStart = new Date(now)
      yearStart.setFullYear(yearEnd.getFullYear() - 1)
      this.yearDate = [yearStart, yearEnd]
    },
    setColumns(u) {
      this.columns = [
        {
          zh: "时间",
          en: "Time",
          dataIndex: "datetime",
          key: "datetime",
          fixed: false
        },
        {
          zh: "平均用气量(" + u + "/min)",
          en: "Average Gas Consumption(" + u + "/min)",
          dataIndex: "avgGasConsumption",
          key: "avgGasConsumption",
          fixed: 2
        },
        {
          zh: "流量计累积(" + u + ")",
          en: "Flow Meter Accumulation(" + u + ")",
          dataIndex: "flowMeterAccumulation",
          key: "flowMeterAccumulation",
          fixed: 2
        },
        {
          zh: "小时用电量(kW·h)",
          en: "Power per hour(kW·h)",
          dataIndex: "avgPower",
          key: "avgPower",
          fixed: 2
        },
        {
          zh: "电表累积(kW·H)",
          en: "Electricity Meter Accumulation(kW·H)",
          dataIndex: "electricityMeterAccumulation",
          key: "electricityMeterAccumulation",
          fixed: 2
        },
        {
          zh: "平均单耗(kW·H/" + u + ")",
          en: "Average Consumption(kW·H/" + u + ")",
          dataIndex: "avgConsumption",
          key: "avgConsumption",
          fixed: 5
        },
        {
          zh: "比功率(kW/" + u + "/min)",
          en: "Specific Power(kW/" + u + "/min)",
          dataIndex: "specificPower",
          key: "specificPower",
          fixed: 4
        }
      ]
    },
    setPoints(u) {
      this.pointsOfCharts = [
        {
          title: {
            zh: "用气量",
            en: "Gas Consumption"
          },
          description: {
            zh: "用气量(" + u + "/min)",
            en: "Gas Consumption(" + u + "/min)"
          },
          dataIndex: "avgGasConsumption",
          key: "avgGasConsumption",
          min: "0.00",
          max: "0.00",
          fixed: 2
        },
        {
          title: {
            zh: "能耗",
            en: "Power"
          },
          description: {
            zh: "能耗(kW·H)",
            en: "Power(kW·H)"
          },
          dataIndex: "avgPower",
          key: "avgPower",
          min: "0.00",
          max: "0.00",
          fixed: 2
        },
        {
          title: {
            zh: "单耗",
            en: "Consumption"
          },
          description: {
            zh: "单耗(kW·H/" + u + ")",
            en: "Consumption(kW·H/" + u + ")"
          },
          dataIndex: "avgConsumption",
          key: "avgConsumption",
          min: "0.00000",
          max: "0.00000",
          fixed: 5
        },
        {
          title: {
            zh: "比功率",
            en: "Specific Power"
          },
          description: {
            zh: "比功率(kW/" + u + "/min)",
            en: "Specific Power(kW/" + u + "/min)"
          },
          dataIndex: "specificPower",
          key: "specificPower",
          min: "0.0000",
          max: "0.0000",
          fixed: 4
        }
      ]
    },
    async render() {
      const devices = await this.requestDevcieInfo()

      if (devices) {
        this.customerName = devices[0].customer?.company || ""
        this.devices = devices.map(d => {
          const dd = {
            ...d
          }
          if (d.code === this.$route.query.code) {
            dd.selected = true
          } else {
            dd.selected = false
          }

          return dd
        })

        const aggregateProtocolsMap = {}
        this.devices_aggregate = devices.map(d => {
          const dd = {
            ...d
          }
          if (d.code === this.$route.query.code) {
            dd.selected = true
          } else {
            dd.selected = false
          }

          aggregateProtocolsMap[d.protocolCode] = {}

          return dd
        })

        const aggregatePointsMap = {}, promises = []
        let n = 0
        for (let a in aggregateProtocolsMap) {
          n++
          promises.push(new Promise(async resolve => {
            try {
              const { data: { points } } = await getProtocol(a)
              
              let p
              for (let i = 0; i < points.length; i++) {
                p = points[i]

                if (aggregatePointsMap[p.code]) {
                  aggregatePointsMap[p.code].count++
                } else {
                  aggregatePointsMap[p.code] = {
                    ...p,
                    count: 1
                  }
                }
              }
            } catch(e) {
              console.log(e)
            } finally {
              resolve()
            }
          }))
        }
        await Promise.all(promises)
        const points = []
        let p
        for (let a in aggregatePointsMap) {
          p = aggregatePointsMap[a]

          if (p.count === n && p.read !== false && p.dataWrite !== 2) {
            points.push(p)
          }
        }

        this.pointsOptions = points
      }

      this.isDeviceLoading = false

      this.renderDataReport()
    },
    /* 多语言 */
    translate() {
      locale.use(this[this.lang])
      this.pickerOptions = {
        shortcuts: [
          {
            text: this.$t("station.tld"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t("station.tlw"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t("station.tlm"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit("pick", [start, end])
            }
          }
        ]
      }
      this.messageOfDeviceFold = this.isDeviceFold
        ? this.$t("buttons.expand")
        : this.$t("buttons.fold")

      this.messageOfDeviceFold_aggregate = this.isDeviceFold_aggregate
        ? this.$t("buttons.expand")
        : this.$t("buttons.fold")

      if (this.charts) {
        this.renderCharts()
      }
    },
    /* 设备选择 */
    changeDeviceFolding() {
      this.isDeviceFold = !this.isDeviceFold
      this.messageOfDeviceFold = this.isDeviceFold
        ? this.$t("buttons.expand")
        : this.$t("buttons.fold")
    },
    /* 主体_参数设置及按钮 */
    changeTimeType(t) {
      this.activeTimeType = t
      this.isContentLoading = true
      this.renderDataReport()
    },
    reload() {
      this.isContentLoading = true
      this.renderDataReport()
    },
    async renderDataReport() {
      this.setColumns(this.unit)
      this.setPoints(this.unit)
      const deviceCodes = []
      let d

      for (let i = 0; i < this.devices.length; i++) {
        d = this.devices[i]
        if (d.selected) {
          deviceCodes.push(d.code)
        }
      }

      if (deviceCodes.length) {
        const codes = deviceCodes + ""
        switch (this.activeTimeType) {
          case "day": {
            if (!this.dayDate) {
              this.isContentLoading = false
              return this.$message.warning(this.$t("device.selectRange"))
            }

            const date = moment(+this.dayDate).format("YYYY-MM-DD")
            this.datas = await this.requestDayReportData(codes, date, this.unit)
            break
          }
          case "month": {
            if (!this.monthDate) {
              this.isContentLoading = false
              return this.$message.warning(this.$t("device.selectRange"))
            }
            const gap = (this.monthDate[1] - this.monthDate[0]) / 1000 / 60 / 60 / 24
            if (gap > 31) {
              this.isContentLoading = false
              return this.$message.warning(this.$t("messages.moreThanOneMonth"))
            }
            const start = moment(+this.monthDate[0]).format("YYYY-MM-DD")
            const end = moment(+this.monthDate[1]).format("YYYY-MM-DD")
            this.datas = await this.requestMonthReportData(codes, start, end, this.unit)
            break
          }
          case "year": {
            if (!this.yearDate) {
              this.isContentLoading = false
              return this.$message.warning(this.$t("device.selectRange"))
            }
            const start = moment(+this.yearDate[0]).format("YYYY-MM-DD")
            const end = moment(+this.yearDate[1]).format("YYYY-MM-DD")
            this.datas = await this.requestYearReportData(codes, start, end, this.unit)
            break
          }
          default: {
            this.datas = []
            break
          }
        }
      } else {
        this.datas = []
        if (this.charts) {
          for (let c in this.charts) {
            this.charts[c].dispose()
          }
          this.charts = null
        }
      }

      this.$nextTick(this.renderCharts)

      this.isContentLoading = false
    },
    async exportAsExcel() {
      this.isExporting = true

      const deviceCodes = []
      let d

      for (let i = 0; i < this.devices.length; i++) {
        d = this.devices[i]
        if (d.selected) {
          deviceCodes.push(d.code)
        }
      }
      
      const result = await this.requestExportReportData(deviceCodes + "")
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result.data], { type: "application/vnd.ms-excel" }))
        const link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.download = `${result.prefix}${this.customerName}能效分析仪数据报表.xlsx`
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success("导出成功", 1)
      }

      this.isExporting = false
    },
    showAggregate() {
      this.isAggregateVisible = true

      let time
      switch(this.activeTimeType) {
        case "day":
          if (this.dayDate) {
            time = new Date(this.dayDate)
          } else {
            time = new Date()
          }
          const t = []
          time.setHours(0, 0, 0, 0)
          t.push(new Date(time))
          time.setHours(23, 59, 59, 999)
          t.push(new Date(time))
          this.aggregateTimeValue = t
          break
        case "month":
          if (this.monthDate) {
            this.aggregateTimeValue = [new Date(this.monthDate[0].setHours(0, 0, 0, 0)), new Date(this.monthDate[1].setHours(23, 59, 59, 999))]
          } else {
            time = new Date()
            const end = new Date(time.setHours(23, 59, 59, 999))
            let start = new Date(time.setMonth(time.getMonth() - 1))
            start.setHours(0, 0, 0, 0)
            this.aggregateTimeValue = [start, end]
          }
          break
        case "year":
          if (this.yearDate) {
            this.aggregateTimeValue = [new Date(this.yearDate[0].setHours(0, 0, 0, 0)), new Date(this.yearDate[1].setHours(23, 59, 59, 999))]
          } else {
            time = new Date()
            const end = new Date(time.setHours(23, 59, 59, 999))
            let start = new Date(time.setFullYear(time.getFullYear() - 1))
            start.setHours(0, 0, 0, 0)
            this.aggregateTimeValue = [start, end]
          }
          break
        default:
          break
      }
    },
    /* 主体_图表 */
    initCharts() {
      this.charts = {}

      let p
      for (let i = 0; i < this.pointsOfCharts.length; i++) {
        p = this.pointsOfCharts[i]
        this.charts[p.key] = this.$echarts.init(document.getElementById(p.key))
      }
    },
    renderCharts() {
      if (!this.charts) {
        this.initCharts()
      }

      const colors = ["#B36A5F", "#5FAE96", "orange", "#4F72CB"]

      const isDay = this.activeTimeType === "day"

      let p, option, x, data, d, v
      for (let i = 0; i < this.pointsOfCharts.length; i++) {
        p = this.pointsOfCharts[i]
        p.min = Infinity
        p.max = -Infinity
        x = []
        data = []

        for (let j = 0; j < this.datas.length - 1; j++) {
          d = this.datas[j]
          x.push(isDay ? d.datetime.slice(11, 16) : d.datetime)
          v = +d[p.key]
          if (v > 0) {
            p.min = Math.min(p.min, v)
            p.max = Math.max(p.max, v)
          }
          data.push(v.toFixed(p.fixed))
        }

        if (p.min === Infinity) {
          p.min = 0
        }
        if (p.max === -Infinity) {
          p.max = 0
        }
        p.min = (+p.min).toFixed(p.fixed)
        p.max = (+p.max).toFixed(p.fixed)

        option = {
          grid: {
            top: "23%",
            left: "10%",
            right: "12%",
            bottom: isDay ? "11%" : "22%"
          },
          tooltip: {
            trigger: "axis"
          },
          xAxis: {
            type: "category",
            data: x,
            boundaryGap: true,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: isDay ? 0 : 40,
              color: "#fff"
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            }
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            },
            axisLabel: {
              color: "#fff"
            }
          },
          series: [
            {
              name: p.description[this.lang],
              type: this.activeChartType,
              lineStyle: {
                width: 3,
                color: colors[i]
              },
              itemStyle: {
                color: colors[i]
              },
              label: {
                show: true,
                color: "#fff",
                rotate: isDay ? 0 : 50,
                position: "top"
              },
              smooth: false,
              symbolSize: 0,
              data
            }
          ]
        }

        this.charts[p.key].setOption(option, {
          replaceMerge: [
            "xAxis",
            "yAxis",
            "series",
            "tooltip"
          ]
        })
      }
    },
    changeChartType(t) {
      this.activeChartType = t
      this.renderCharts()
    },
    /* 数据分布区间统计 */
    startDrag(e) {
      const { aggregate } = this.$refs
      const x = e.pageX - aggregate.offsetLeft
      const y = e.pageY - aggregate.offsetTop

      function move(e) {
        aggregate.style.left = e.pageX - x + "px"
        aggregate.style.top = e.pageY - y + "px"
      }
      document.addEventListener("mousemove", move)

      function unbindMove() {
        document.removeEventListener("mousemove", move)
      }
      document.addEventListener("mouseup", unbindMove)

      this.unbindMove = unbindMove
    },
    clearAggregate() {
      this.isAggregateVisible = false
      this.aggregateTimeValue = null
      this.selectedDeviceType = undefined
      this.selectedPoint = undefined
      this.ranges_aggregate = []
      this.pieChart?.clear()
      this.originChart?.clear()
    },
    changeDeviceFold_aggregate() {
      this.isDeviceFold_aggregate = !this.isDeviceFold_aggregate

      this.messageOfDeviceFold_aggregate = this.isDeviceFold_aggregate
        ? this.$t("buttons.expand")
        : this.$t("buttons.fold")
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    addRange_aggregate() {
      this.ranges_aggregate.push({
        id: nanoid(),
        min: undefined,
        max: undefined
      })
    },
    deleteLastRange() {
      this.ranges_aggregate.pop()
    },
    async analyse_aggregate() {
      if (!this.selectedPoint) {
        return this.$message.warning(this.$t("device.selectPoints"))
      }
      this.isAggregateAnalysing = true

      const ranges = []
      let r
      for (let i = 0; i < this.ranges_aggregate.length; i++) {
        r = this.ranges_aggregate[i]
        if (!isNaN(r.min) && !isNaN(r.max)) {
          ranges.push({
            min: +r.min,
            max: +r.max,
            value: 0,
            name: r.min + " ~ " + r.max
          })
        }
      }

      let deviceId = this.devices_aggregate.filter(d => d.selected).map(d => d.id) + ""
      try {
        let startTime = +new Date(this.aggregateTimeValue[0])
        let endTime = +new Date(this.aggregateTimeValue[1])
        const { data } = await getAggregateHistoryData({
          deviceId,
          pointCode: this.selectedPoint,
          startTime,
          endTime
        })
        let d
        for (let i = 0; i < data.length; i++) {
          d = data[i][this.selectedPoint]
          for (let j = 0; j < ranges.length; j++) {
            r = ranges[j]
            if (d >= r.min && d < r.max) {
              r.value++
            }
          }
        }
        let count = data.length
        for (let i = 0; i < ranges.length; i++) {
          count -= ranges[i].value
        }
        if(count > 0) {
          ranges.push({
            name: "其它",
            value: count
          })
        }
        this.renderPieChart(ranges)
        const point = this.pointsOptions.find(p => p.code === this.selectedPoint)
        let pointName = ""
        if (point) {
          pointName = point.name
        }
        this.renderOriginChart(data.map(d => [+new Date(d.time), d[this.selectedPoint]]), pointName)
      } catch(e) {
        console.log(e)
      } finally {
        this.isAggregateAnalysing = false
      }
    },
    renderPieChart(r) {
      if (!this.pieChart) {
        this.pieChart = this.$echarts.init(document.getElementById("pie"))
      }
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: [0, '70%'],
            label: {
              fontSize: 16,
              formatter: "{b}: {d}%",
              show: true,
              color: "inherit"
            },
            labelLine: {
              show: true
            },
            data: r.map(d => ({
              name: d.name,
              value: d.value
            }))
          }
        ]
      }

      this.pieChart.setOption(option)
    },
    renderOriginChart(data, name) {
      if (!this.originChart) {
        this.originChart = this.$echarts.init(document.getElementById("origin"))
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        grid: {
          top: "5%",
          bottom: "27%",
          left: "8%",
          right: "3%"
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ],
        series: [
          {
            name,
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {},
            data
          }
        ]
      }
      this.originChart.setOption(option)
    },
    /* 请求 */
    async requestDevcieInfo() {
      let result = null

      try {
        const { data } = await searchDeviceList(
          1,
          10000,
          {
            query: [],
            filter: [
              {
                field: "customerId",
                value: this.$route.query.ci
              },
              {
                field: "type",
                value: this.$route.query.type
              },
              {
                field: "mode",
                value: "and"
              }
            ],
            sort: []
          }
        )

        if (data.total) {
          result = data.records
        }
      } catch(e) {
        console.log(e)
      } finally {
        return result
      }
    },
    async requestDayReportData(codes, date, unit) {
      let result = []

      try {
        const { data } = await getNXFXYDayReportData(codes, date, unit)
        result = data
      } catch(e) {
        console.log(e)
      } finally {
        return result
      }
    },
    async requestMonthReportData(codes, start, end, unit) {
      let result = []

      try {
        const { data } = await getNXFXYMonthReportData(codes, start, end, unit)
        result = data
      } catch(e) {
        console.log(e)
      } finally {
        return result
      }
    },
    async requestYearReportData(codes, start, end, unit) {
      let result = []

      try {
        const { data } = await getNXFXYYearReportData(codes, start, end, unit)
        result = data
      } catch(e) {
        console.log(e)
      } finally {
        return result
      }
    },
    async requestExportReportData(codes) {
      let result = null, date

      try {
        switch (this.activeTimeType) {
          case "day": {
            if (!this.dayDate) {
              this.$message.warning(this.$t("device.selectRange"))
              result = null
              return result
            }
            date = moment(+this.dayDate).format("YYYY-MM-DD")
            const { data } = await exportNXFXYDayReportData(codes, date, date, this.unit)
            result = {
              data,
              prefix: date
            }
            break
          }
          case "month": {
            if (!this.monthDate) {
              this.$message.warning(this.$t("device.selectRange"))
              result = null
              return result
            }

            const gap = (this.monthDate[1] - this.monthDate[0]) / 1000 / 60 / 60 / 24
            if (gap > 31) {
              this.$message.warning(this.$t("messages.moreThanOneMonth"))
              result = null
              return result
            }
            const start = moment(+this.monthDate[0]).format("YYYY-MM-DD")
            const end = moment(+this.monthDate[1]).format("YYYY-MM-DD")
            const { data } = await exportNXFXYMonthReportData(codes, start, end, this.unit)
            result = {
              data,
              prefix: start + " ~ " + end
            }
            break
          }
          case "year": {
            if (!this.yearDate) {
              this.$message.warning(this.$t("device.selectRange"))
              result = null
              return result
            }
            const start = moment(+this.yearDate[0]).format("YYYY-MM-DD")
            const end = moment(+this.yearDate[1]).format("YYYY-MM-DD")
            const { data } = await exportNXFXYYearReportData(codes, start, end, this.unit)
            result = {
              data,
              prefix: start + " ~ " + end
            }
            break
          }
          default: {
            result = null
            break
          }
        }
      } catch(e) {
        result = null
        console.log(e)
      } finally {
        return result
      }
    }
  }
}
</script>

<style lang="less" scoped>
div, ul, li, p, label, hr, h1, h2, h3 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

li {
  list-style: none;
}

.dataStatistics {
  position: relative;
  background-color: #2f3d4f;
  min-height: 860px;
  padding: 20px;

  .customerName {
    color: #fff;
    font-size: 24px;
  }

  .device_selector {
    width: 100%;
    background-color: #212d3f;
    margin-top: 18px;
    display: flex;
    justify-content: center;
    align-items: center;

    .device_wrapper {
      width: 100%;
      padding: 10px;

      header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
          color: #f8fced;
        }

        span {
          color: #2d8cfa;
          cursor: pointer;

          .anticon-double-right, .anticon-double-left {
            transform: rotateZ(90deg);
          }
        }
      }

      .splitLine {
        margin-top: 10px;
        border-bottom: 1px solid #1976cf;
      }

      .devices {
        overflow: hidden;
  
        li {
          float: left;
          margin: 10px 0 10px 10px;
          width: 150px;
          height: 25px;
          font-size: 16px;
          background-color: #4a90e2;
          color: #f8fced;
          text-align: center;

          label {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;
          }

          .device_name {
            color: #fff;
            float: left;
            width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          input[type^="checkbox"] {
            width: 15px;
            height: 15px;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
    }
  }

  .content_wrapper {
    width: 100%;
    min-height: 530px;
    margin-top: 18px;
    position: relative;

    .loader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .content {
      width: 100%;

      .controller {
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          border: 1px solid #4e5a69;
          color: #cbcfc7;
          text-align: center;
          line-height: 30px;
          cursor: pointer;

          &.active {
            background-color: #2199e9;
            color: #f8fced;
          }

          &:nth-child(2) {
            border-left: none;
            border-right: none;
          }
        }

        /deep/ .ant-select-selection--single {
          background-color: transparent;
          color: #CBCFC7;
          border-color: #4e5a69;
          
          .ant-select-selection__rendered {
            margin-top: 1px;
          }
        }

        .buttons {
          display: inline-block;
          transform: translateY(-1px);
          margin-left: 5px;

          /deep/ .ant-btn {
            margin-left: 10px;
          }
        }
      }

      .table_wrapper {
        margin-top: 18px;

        table {
          width: 100%;
          border-top: 1px solid #4a5665;
          border-left: 1px solid #4a5665;
          color: #a7adb5;

          th, td {
            height: 40px;
            padding-left: 15px;
            border-bottom: 1px solid #5b6574;
            border-right: 1px solid #5b6574;
          }

          th {
            background-color: #485464;
          }
        }
      }

      .charts_group_wrapper {
        width: 100%;
        position: relative;
        margin-top: 18px;

        .types {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;

          li {
            color: #a5abb3;
            margin-left: 10px;
            font-size: 18px;
            cursor: pointer;
  
            &.active {
              color: #2199e9;
            }
          }
        }

        .charts_group {
          width: 100%;

          h3 {
            color: #a5abb3;
            font-size: 20px;
            margin-top: 20px;
          }

          .chart_wrapper {
            width: 100%;
            position: relative;

            .chart {
              width: 100%;
              height: 240px;
            }

            .tooltip {
              position: absolute;
              right: 1%;
              top: 20%;
  
              p {
                color: #fff;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.remarkUl {
  li {
    margin-bottom: 15px;
    font-size: 15px;

    i {
      font-style: normal;
      font-weight: 600;
    }
  }
}

/deep/ .el-date-editor {
  transform: translateY(-1px);
  margin-left: 15px;
  background-color: #2f3d4f;

  .el-input__icon::before {
    top: 0px;
  }

  .el-input__inner {
    outline: none;
    background-color: #2F3D4F;
    color: #CBCFC7;
    border-color: #4e5a69;
  }
}

/deep/ .el-range-editor {
  border: 1px solid #4E5A69;

  .el-range-input {
    color: #CBCFC7;
  }

  .el-icon-date::before {
    top: -5px;
  }

  .el-range-separator {
    line-height: 24px;
  }

  input {
    color: #CBCFC7;
  }

  .el-range__close-icon {
    margin-top: 0;
  }
}

.mask {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 1380px;
  height: 860px;
  background-color: #2F3D4F;
  border: 1px solid #ccc;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  cursor: move;
  padding: 30px;
  z-index: 10;

  .wrapper {
    cursor: default;
  }

  i.anticon-close {
    font-size: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    cursor: pointer;
  }

  h2 {
    color: #fff;
  }

  .header {
    display: flex;
    align-items: center;
  }

  .search {
    display: flex;
    align-items: center;
    margin-top: 16px;

    /deep/ .el-date-editor {
      transform: translateY(0px);
      margin-left: 0;
    }

    label {
      color: #fff;
    }

    /deep/ .ant-select-selection {
      background-color: #2F3D4F;
    }

    /deep/ .ant-select-selection-selected-value {
      color: #fff;
    }

    /deep/ .el-icon-time {
      position: relative;
      margin-left: 0;
      margin-top: 0;
      top: 0;
    }
  }

  .ranges {
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    li {
      margin: 0 0 8px 10px;
      display: flex;
      align-items: center;
    }

    /deep/ .ant-input {
      background-color: #2F3D4F;
      color: #fff;
    }
  }

  .content {
    width: 100%;
    height: 530px;
    border: 1px solid #ccc;
    margin: 0;
    display: flex;
    margin-top: 22px;
    box-sizing: border-box;

    h3 {
      color: #fff;
      margin-left: 1em;
      margin-top: .2em;
    }
  }
  .left {
    width: 50%;
    border-right: 1px solid #ccc;
    height: 100%;

    .top {
      height: 40%;
      border-bottom: 1px solid #ccc;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        width: 8px;
        background-color: #4961a3;
        border-radius: 4px;
      }
    }
    .bottom {
      height: 60%;
    }
  }

  .right {
    width: 50%;
  }

  .chart {
    width: 100%;
    height: 85%;
  }
}

.mask::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.mask::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.mask::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}

.ml {
  margin-left: .5em;
}
</style>